import { defineComponent as _defineComponent } from 'vue'
import { vShow as _vShow, createElementVNode as _createElementVNode, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock, unref as _unref } from "vue"

const _hoisted_1 = { style: {"margin":"0"} }
const _hoisted_2 = { style: {"margin":"0"} }

import ArticleQuantityCardSliding from "@/components/article/ArticleQuantityCardSliding.vue";
import { IonList, } from '@ionic/vue';
import { TArticle } from '@/const/types/article';



export default /*#__PURE__*/_defineComponent({
  __name: 'StartStocktakingArticleList',
  props: {
    articles: null
  },
  emits: ['onOpenChangeQuantityAlert', 'onOpenDeleteSignleArticleAlert'],
  setup(__props: any, { emit: emits }) {

const props = __props as {
    articles: TArticle[];
};





return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(IonList), null, {
    default: _withCtx(() => [
      _withDirectives(_createElementVNode("p", _hoisted_1, " At the selected place, these products are currently scanned (scan to increase quantity): ", 512), [
        [_vShow, props.articles.length >= 1]
      ]),
      _withDirectives(_createElementVNode("p", _hoisted_2, " At the selected place, no products have been scanned yet (scan to increase quantity): ", 512), [
        [_vShow, props.articles.length < 1]
      ]),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.articles, (article) => {
        return (_openBlock(), _createBlock(ArticleQuantityCardSliding, {
          key: article.code,
          article: article,
          "is-new": article.isNew,
          onOpenChangeQuantityAlert: ($event: any) => (emits('onOpenChangeQuantityAlert', article)),
          onDeleteSingleArticle: ($event: any) => (emits('onOpenDeleteSignleArticleAlert', article))
        }, {
          right: _withCtx(() => [
            _createTextVNode(_toDisplayString(article.quantity) + " szt. ", 1)
          ]),
          _: 2
        }, 1032, ["article", "is-new", "onOpenChangeQuantityAlert", "onDeleteSingleArticle"]))
      }), 128))
    ]),
    _: 1
  }))
}
}

})